import { BrowserRouter as Router } from 'react-router-dom'

import RoutesApp from '~pages'
import { UpdatePasswordPopin } from '~pages/Authenticated/Home/components'
import InfoBanner from "./components/InfoBanner";

function App() {

  return (
    <Router>
      <InfoBanner />
      <UpdatePasswordPopin />
      <RoutesApp />
    </Router>
  )
}

export default App
